export default __webpack_public_path__ + "static/media/feltro.820d07d0.png";